import React from 'react';
import "./styles.scss";

const Loader = () => {
    return (
        <div className="loader">
            <div className="loader__dots">
                <svg className="loader__dots__dot"></svg>
                <svg className="loader__dots__dot"></svg>
                <svg className="loader__dots__dot"></svg>
                <svg className="loader__dots__dot"></svg>
            </div>

            <svg xmlns="http://www.w3.org/2000/svg" version="1.1"  height="40px">
            <defs>
                <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
                    <feComposite in="SourceGraphic" in2="goo" operator="atop"/>
                </filter>
            </defs>
            </svg>
        </div>
    );
};

export default Loader;


// WEBPACK FOOTER //
// ./src/components/ui/loader/Loader.jsx